// extracted by mini-css-extract-plugin
module.exports = {"spaceBetween":"_54g3b","waveformContainer":"_2m4YA","timeContainer":"_2ujfw","icon":"_2Ocov","button":"_36G5E","audioLength":"_2mZVB"};